import React, { MouseEventHandler, useCallback } from 'react'
import { connect } from 'react-redux'
import AdditionalGuestsMessage from './AdditionalGuestsMessage'
import AdditionalGuestsModal from './AdditionalGuestsModal'
import useToggle from 'hooks/useToggle'
import { getSupportContact } from 'selectors/supportContactSelector'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import LineExclamationTriangleIcon from 'components/Luxkit/Icons/line/LineExclamationTriangleIcon'
import { useTranslation } from 'react-i18next'

interface Props {
  complex: boolean;
  heading?: string;
  description: string;
  modalContent?: string;
  currentContact: App.GeoContacts;
  triangleWarning?: boolean;
}

function AdditionalGuestsPopup({
  complex,
  heading,
  description,
  modalContent,
  currentContact,
  triangleWarning,
}:Props) {
  const { value: modalOpened, toggle: toggleModalOpened } = useToggle(false)
  const { t } = useTranslation('common')
  const toggleModalCallback = useCallback<MouseEventHandler<HTMLButtonElement>>((e) => {
    e.preventDefault()
    toggleModalOpened()
  }, [toggleModalOpened])

  return <>
    {complex && <MessageBanner
      kind="warning"
      icon={triangleWarning ? <LineExclamationTriangleIcon /> : undefined}
      heading={heading}
      description={description}
      secondaryActionButtonProps={modalContent ? { onClick: toggleModalCallback, children: t('Details') } : undefined}
    />}

    {!complex && <AdditionalGuestsMessage
      message={description}
      onClick={modalContent ? toggleModalCallback : undefined}
    />}

    <AdditionalGuestsModal
      isOpen={modalOpened}
      onClose={toggleModalCallback}
      description={modalContent}
      currentContact={currentContact}
    />
  </>
}

const mapStateToProps = (state: App.State) => ({
  currentContact: getSupportContact(state),
})

export default connect(mapStateToProps)(AdditionalGuestsPopup)
